import React from "react";

export default ({width = "26px", height = "26px"}) => (
    <svg width={width} height={height} viewBox="0 0 24 20" fill="none">
        <path d="M11.9617 5.1853L3.73309 11.517V19.9999H10.345V13.7833H13.8576V19.9999H20.1903V11.517L11.9617 5.1853Z" fill="#1C3A54"/>
        <path d="M20.5348 6.59524V2.25799H17.0694V3.92934L11.9616 0L0 9.20189L1.65122 11.3483L11.9616 3.41467L22.272 11.3483L23.9232 9.20194L20.5348 6.59524Z" fill="#0EAFE6"/>
    </svg>
);
